var _style, _g, _path, _path2, _path3, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlaySeeklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.6 64.1",
    style: {
      enableBackground: "new 0 0 217.6 64.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#9C9B9D;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#5BC8F3;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:url(#SVGID_00000145017901298661148460000003434459439677259653_);}\r\n\t.st6{fill:url(#SVGID_00000088134965467324661000000007620225318858975386_);}\r\n\t.st7{display:inline;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Google_Play"
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.2,116.4H-35.9c-4.1,0-7.4-3.3-7.4-7.4v-212.9c0-4.1,3.3-7.4,7.4-7.4h283.1c4.1,0,7.4,3.3,7.4,7.4V109 C254.6,113,251.3,116.4,247.2,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.4,64.1H8.2c-4.5,0-8.2-3.7-8.2-8.2V8.2C0,3.7,3.7,0,8.2,0h201.2c4.5,0,8.2,3.7,8.2,8.2v47.7 C217.6,60.4,213.9,64.1,209.4,64.1z M8.2,1.6c-3.6,0-6.6,2.9-6.6,6.6v47.7c0,3.6,2.9,6.6,6.6,6.6h201.2c3.6,0,6.6-2.9,6.6-6.6 V8.2c0-3.6-2.9-6.6-6.6-6.6H8.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.8,35c-3.8,0-6.9,2.9-6.9,6.8c0,3.9,3.1,6.8,6.9,6.8c3.8,0,6.9-2.9,6.9-6.8 C116.6,37.9,113.6,35,109.8,35z M109.8,46c-2.1,0-3.9-1.7-3.9-4.1c0-2.5,1.8-4.1,3.9-4.1c2.1,0,3.9,1.7,3.9,4.1 C113.6,44.3,111.8,46,109.8,46z M94.8,35c-3.8,0-6.9,2.9-6.9,6.8c0,3.9,3.1,6.8,6.9,6.8c3.8,0,6.9-2.9,6.9-6.8 C101.7,37.9,98.6,35,94.8,35z M94.8,46c-2.1,0-3.9-1.7-3.9-4.1c0-2.5,1.8-4.1,3.9-4.1c2.1,0,3.9,1.7,3.9,4.1 C98.7,44.3,96.9,46,94.8,46z M77,37.1V40h6.9c-0.2,1.6-0.8,2.8-1.6,3.7c-1,1-2.6,2.1-5.4,2.1c-4.3,0-7.6-3.4-7.6-7.7 s3.3-7.7,7.6-7.7c2.3,0,4,0.9,5.2,2.1l2-2c-1.7-1.7-4-2.9-7.3-2.9c-5.9,0-10.8,4.8-10.8,10.6c0,5.9,4.9,10.6,10.8,10.6 c3.2,0,5.5-1,7.4-3c1.9-1.9,2.5-4.6,2.5-6.8c0-0.7-0.1-1.3-0.2-1.8H77z M149.9,39.4c-0.6-1.5-2.3-4.4-5.9-4.4 c-3.5,0-6.5,2.8-6.5,6.8c0,3.8,2.9,6.8,6.8,6.8c3.1,0,4.9-1.9,5.7-3l-2.3-1.6c-0.8,1.1-1.8,1.9-3.4,1.9c-1.5,0-2.6-0.7-3.3-2.1 l9.1-3.8L149.9,39.4z M140.5,41.7c-0.1-2.6,2-4,3.6-4c1.2,0,2.2,0.6,2.5,1.5L140.5,41.7z M133.1,48.3h3V28.2h-3V48.3z  M128.2,36.6h-0.1c-0.7-0.8-2-1.5-3.6-1.5c-3.4,0-6.6,3-6.6,6.9c0,3.8,3.1,6.8,6.6,6.8c1.6,0,2.9-0.7,3.6-1.6h0.1v1 c0,2.6-1.4,4-3.7,4c-1.8,0-3-1.3-3.4-2.4l-2.6,1.1c0.8,1.8,2.7,4,6.1,4c3.5,0,6.5-2.1,6.5-7.1V35.4h-2.9V36.6z M124.7,46 c-2.1,0-3.8-1.7-3.8-4.1c0-2.4,1.7-4.2,3.8-4.2c2,0,3.7,1.8,3.7,4.2C128.4,44.3,126.8,46,124.7,46z M163.9,28.2h-7.2v20.1h3v-7.6 h4.2c3.3,0,6.6-2.4,6.6-6.2S167.3,28.2,163.9,28.2z M164,37.9h-4.3V31h4.3c2.2,0,3.5,1.9,3.5,3.4C167.5,36,166.3,37.9,164,37.9z  M182.6,35c-2.2,0-4.4,1-5.4,3.1l2.7,1.1c0.6-1.1,1.6-1.5,2.7-1.5c1.6,0,3.1,0.9,3.2,2.6v0.2c-0.5-0.3-1.7-0.8-3.1-0.8 c-2.9,0-5.8,1.6-5.8,4.5c0,2.7,2.4,4.4,5,4.4c2,0,3.1-0.9,3.8-2h0.1v1.6h2.9v-7.7C188.7,37,186,35,182.6,35z M182.2,46 c-1,0-2.4-0.5-2.4-1.7c0-1.6,1.7-2.1,3.2-2.1c1.3,0,1.9,0.3,2.7,0.7C185.5,44.7,183.9,46,182.2,46z M199.2,35.4l-3.4,8.7h-0.1 l-3.6-8.7h-3.2l5.4,12.2l-3.1,6.8h3.1l8.3-19H199.2z M172.2,48.3h3V28.2h-3V48.3z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17,12.2c-0.5,0.5-0.7,1.3-0.7,2.3V50c0,1,0.3,1.8,0.7,2.3l0.1,0.1L37,32.4v-0.2V32L17.1,12.1L17,12.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.1902,
    y1: 32.2126,
    x2: 11.3046,
    y2: 32.2126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FBBC0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F9A418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F89B1C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.6,39.1L37,32.4v-0.2V32l6.6-6.6l0.1,0.1l7.9,4.5c2.2,1.3,2.2,3.4,0,4.6L43.8,39L43.6,39.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079471782905341168460000002772474462728516527_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0989,
    y1: 35.9003,
    x2: 3.5253,
    y2: 72.4739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4447"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5166C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079471782905341168460000002772474462728516527_)"
    },
    d: "M43.8,39L37,32.2l-20,20 c0.7,0.8,2,0.9,3.3,0.1L43.8,39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021828115591093734390000008585513864124835992_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.3623,
    y1: -8.213,
    x2: 33.2237,
    y2: 21.6484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#269E6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05089003,
    style: {
      stopColor: "#2BA06F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    style: {
      stopColor: "#53B26B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7971,
    style: {
      stopColor: "#6BBD69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#74C168"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021828115591093734390000008585513864124835992_)"
    },
    d: "M43.8,25.4L20.3,12.1 c-1.4-0.8-2.6-0.7-3.3,0.1l20,20L43.8,25.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.9,13.3c-0.6-0.5-1.4-0.9-2.3-0.9c-2,0-3.5,1.6-3.5,3.6c0,2,1.5,3.6,3.5,3.6c1.7,0,2.9-1,3-2.6H72V16h4.1 c0,3.3-1.8,4.9-4.5,4.9c-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.1-4.9,4.8-4.9c1.2,0,2.4,0.5,3.2,1.2L73.9,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.5,11.3v1.2h-4.3v3h3.8v1.2h-3.8v2.9h4.5v1.2h-5.7v-9.5H83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.8,11.3v1.2h-2.9v8.3h-1.3v-8.3h-2.9v-1.2H91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.9,11.3v9.5h-1.3v-9.5H97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.6,11.3v1.2h-2.9v8.3h-1.3v-8.3h-2.9v-1.2H106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.6,11.2c2.7,0,4.8,2.2,4.8,4.9c0,2.7-2.1,4.8-4.8,4.8c-2.7,0-4.8-2.2-4.8-4.8 C110.8,13.4,112.9,11.2,115.6,11.2z M115.6,19.7c2,0,3.5-1.6,3.5-3.6c0-2-1.5-3.6-3.5-3.6c-2,0-3.5,1.6-3.5,3.6 C112.1,18.1,113.6,19.7,115.6,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128,20.8l-4.3-7.1v7.1h-1.3v-9.5h1.3l4.3,7.1v-7.1h1.3v9.5H128z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "App_Store",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaySeeklogo);
export default __webpack_public_path__ + "static/media/google-play-seeklogo.4cb7d394132b05ac10de1da376bbc4e5.svg";
export { ForwardRef as ReactComponent };